import { render } from "./EventComponent.vue?vue&type=template&id=674a797c"
import script from "./EventComponent.vue?vue&type=script&lang=js"
export * from "./EventComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__